<template>
  <BaseModal
    modal-title="Укажите номер телефона"
    :opened="true"
    ref="modalRef"
    @close="$emit('close')"
  >
    <p class="text-muted mb-4">
      Спасибо за регистрацию! Остался последний шаг — укажите номер телефона.
    </p>
    <LoadingBlock :loading="loading">
      <form @submit.prevent="submitPhone">
        <div class="mb-4">
          <label class="form-label">Номер телефона</label>
          <input
            type="tel"
            class="form-control"
            placeholder="+7XXXXXXXXXX"
            v-model="phone"
            required
          />
          <small v-if="phoneError" class="text-danger">{{ phoneError }}</small>
        </div>
        <div class="text-end">
          <button type="submit" class="btn btn-primary waves-effect" :disabled="!isValidPhone">
            Сохранить
          </button>
        </div>
      </form>
    </LoadingBlock>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/Modal.vue";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import { updateUser } from "@/api/user";
import { Message, Messages } from "@/data/messages";

export default {
  name: "RequirePhoneModal",
  components: { BaseModal, LoadingBlock },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  emits: ["success", "close"],
  data() {
    return {
      phone: "+",
      loading: false,
    };
  },
  computed: {
    isValidPhone() {
      const phoneRegex = /^\+\d{10,15}$/;
      return phoneRegex.test(this.phone.trim());
    },
    phoneError() {
      if (!this.phone.trim()) return "";
      return this.isValidPhone
        ? ""
        : "Формат: + и от 10 до 15 цифр (например, +79001234567)";
    },
  },
  methods: {
    async submitPhone() {
      if (!this.isValidPhone) return;
      this.loading = true;
      const message = new Message();
      try {
        const result = await updateUser(this.userId, { phone: this.phone.trim() });
        if (result.status === 200) {
          message.type = "success";
          message.autoremove = 5;
          message.text = "Номер телефона сохранён";
          Messages.list.push(message);
          this.$refs.modalRef.closeModal();
          this.$emit("success");
        } else {
          message.type = "failure";
          message.text = "Не удалось сохранить номер. Попробуйте снова или обратитесь в поддержку.";
          Messages.list.push(message);
        }
      } catch (e) {
        message.type = "failure";
        message.text =
          e.response?.data?.detail ||
          "Не удалось сохранить номер. Попробуйте снова или обратитесь в поддержку.";
        Messages.list.push(message);
      }
      this.loading = false;
    },
  },
};
</script>
